import {
  ChipBadge,
  CustomUploadResponse,
  IStyles,
  IconWrapper,
  ImageWrapper,
  Loader,
  MarksSubmitPopup,
  ScoreProgressBar,
  SelectMenu,
  convertPercentageToMarks,
  deserify,
  formatDateAsDayMonth,
  getDifficultyLevelString,
  getFileExtensionType,
  getFileSizeInMB,
  getFileType,
  getLocalStorage,
  getMediaBasePath,
  pxToRem,
  pxTovW,
  theme,
  uploadFile,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import {
  Box,
  Chip,
  Divider,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  useMediaQuery,
} from '@mui/material';
import {
  AssessmentEnum,
  CloudUpload,
  LiveQuizSession,
  MarkingSchemeEnum,
  ModeOfConductionEnum,
  MultiSubjectSection,
  SessionStatusEnum,
  SubmissionType,
  TaskEnum,
} from '@protos/learning_management/lms.db_pb';
import { HomeworkTask } from '@protos/learning_management/lms.hw.common.apis_pb';
import {
  MultiSubjectMetrics,
  StudentPerformanceInfo,
  StudentSubmissionInfo,
} from '@protos/learning_management/lms.hw.teacher.apis_pb';
import { useGlobalContext } from '../../../app/Context/GlobalContextProvider';
import { ChangeEvent, DragEvent, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../reduxStore/reduxHooks';
import {
  ASSESSMENT_VIEW,
  HOME,
  HOMEWORK_MANAGE,
  HOMEWORK_PERFORMANCE,
  HOMEWORK_SUBMISSION_CUSTOM,
} from '../../../routeHandling/RoutesNomenclature';
import {
  setToastInfo,
  setToastInfoV2,
} from '../../Home/reducer/homeDashboard.slice';
import { StudentSection } from './components/StudentSection';
import {
  AssessmentContent,
  AssessmentTask,
} from '@protos/learning_management/lms.assessment.common.apis_pb';
import {
  BloomLevelBreackdown,
  TeacherAssessmentClassStatsV2,
  TeacherAssessmentClassStatsV3,
  TeacherOmrAssessmentClassStats,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { ChartBox } from './components/ChartBox';
import { StrengthsWeaknessesSection } from './components/StrenghtsAndWeaknessSection';
import { OverLappingPieChart } from './components/OverLappingPieChart';
import { getSubjectNameFromEnum } from '../../Home/home.utils';
import { TeachClassSubjects } from '@protos/user_management/ums.login.apis_pb';
import { get } from 'http';
import ViewReportButton from '../components/ViewReportButton';
import { OmrUploadPopup } from '../../Assessment/OmrAssessment/OmrActive/components/OmrUploadPopup';
import { OmrDownloadButtons } from '../../Assessment/OmrAssessment/OmrActive/components/OmrDownloadButtons';
import { Timestamp } from '@bufbuild/protobuf';
import { CustomUploadFileResponse } from '../../Assessment/reducer/assessmentFlow.slice';
import {
  FileUploadPurpose,
  MimeEnum,
  SignedUrlReponse,
} from '@protos/learning_management/lms.common.apis_pb';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { useLiveQuizContext } from 'apps/teacher/src/app/Context/LiveQuizContextProvider';
import { setSelectedLiveQuizAttempt } from '../reducer/manageHomework.slice';

const styles: IStyles = {
  root: {
    width: '100vw',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    // paddingLeft: { xs: pxToRem(0), md: pxTovW(241) },
    // paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
    gap: { lg: pxTovW(30) },
    padding: {
      md: `${pxTovW(15)} ${pxTovW(20)}`,
      lg: `${pxTovW(15)} ${pxTovW(240)}`,
    },
    paddingTop: { xs: pxToRem(20), md: pxTovW(40) },
    boxSizing: 'border-box',
    overflowX: 'hidden',
  },
  header: {
    width: '100%',
    display: 'flex',
    // flexDirection: 'column',
    paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
    gap: { xs: pxToRem(10), md: pxTovW(22) },
    //
    marginLeft: { xs: pxToRem(20), md: pxTovW(0) },
    alignItems: 'center',
  },
  headImage: {
    width: { xs: pxToRem(74), md: pxToRem(50), lg: pxTovW(124) },
    height: { xs: pxToRem(74), md: pxToRem(50), lg: pxTovW(124) },
    borderRadius: { xs: pxToRem(6), md: pxToRem(6), lg: pxTovW(15) },
    objectFit: 'cover',
  },
  iconBox: {
    width: { xs: '100%', md: '97%', lg: pxTovW(794) },
    height: { xs: pxToRem(100), md: pxTovW(250), lg: pxTovW(209) },
    borderRadius: { xs: '0px', md: pxToRem(10) },
    backgroundColor: '#FFFFFF',
    // backgroundColor: 'red',
    border: { md: '1px solid #E0DFDE' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: pxToRem(10),
    boxSizing: 'border-box',
    boxShadow: `0px 0px ${pxToRem(10)} #0000001F`,
    marginLeft: { xs: pxToRem(0), md: pxTovW(40), lg: pxTovW(40) },
  },
};
export interface ISubmissionProps {
  studentData?: StudentPerformanceInfo;
  marks?: number;
  checkedValue?: boolean;
}
interface IStudentStatus {
  studentId: bigint;
  isSubmitted?: boolean;
  marks?: number;
}
export interface IStatusObj {
  [key: string]: IStudentStatus;
}

export const CompletedHomework = () => {
  // const { homework_id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { setSelectedFunction } = useGlobalContext();

  const { fetchPreviousSessions } = useLiveQuizContext();
  const [previousLiveQuizSessions, setPreviousLiveQuizSessions] = useState<
    LiveQuizSession[]
  >([]);
  const [selectedLiveQuizAttemptNumber, setSelectedLiveQuizAttemptNumber] =
    useState<number | undefined>();

  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const { assessment_list_data, selected_assessment_id } = deserify(
    useAppSelector((state) => state.manageHomework)
  );
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const { isIpadOnly } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [hwClassStats, setHwClassStats] = useState<
    TeacherAssessmentClassStatsV3 | undefined
  >();
  const [hwClassStatsSectionWise, setHwClassStatsSectionWise] = useState<
    TeacherAssessmentClassStatsV3 | undefined
  >();
  const [marksPopupDisplay, setMarksPopupDisplay] = useState(false);
  const [currentHomwork, setCurrentHomwork] = useState<AssessmentTask>();
  const {
    LmsHomewokTeacherAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler,
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsCommonAPIServiceV2ClientWithStatusCodeHandler,
    SchoolAssessmentAPIServiceV1ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const [studentInfo, setStudentInfo] = useState<
    StudentPerformanceInfo | undefined
  >();
  const [selectedSection, setSelectedSection] = useState<
    MultiSubjectMetrics | undefined
  >();
  const [StatusObject, updateStatusObject] = useState<IStatusObj | undefined>();
  const teacher_id = getLocalStorage('userId');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [omrClassStats, setOmrClassStats] = useState<
    TeacherOmrAssessmentClassStats | undefined
  >();
  const [openOmrUploadPopup, setOpenOmrUploadPopup] = useState(false);
  const [omrScanFile, setOmrScanFile] = useState<
    CustomUploadResponse[] | undefined
  >();
  const [assessmentContent, setAssessmentContent] = useState<
    AssessmentContent | undefined
  >();

  // -----------------------------------------------------
  const completedAttempts = [...previousLiveQuizSessions]
    .filter(
      (session) =>
        session.sessionStatus === SessionStatusEnum.SESSION_STATUS_COMPLETED
    )
    .sort(
      (a, b) =>
        Number(a.sessionStartTime?.seconds ?? 0) -
        Number(b.sessionStartTime?.seconds ?? 0)
    );

  const attemptOptionList = completedAttempts
    .map((session, index) => ({
      name: `Attempt ${index + 1}`,
      id: index + 1,
    }))
    .reverse();

  const isOmrAssessment = () => {
    return (
      hwClassStats?.assessment?.modeOfConduction ===
        ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR ||
      currentHomwork?.modeOfConduction ===
        ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    );
  };

  // -----------------------------------------------------

  useEffect(() => {
    if (!selected_assessment_id) return;

    const homework = assessment_list_data?.ended.find(
      (item) => item.assessmentId === selected_assessment_id
    );

    setCurrentHomwork(homework);

    const loadHomework = async () => {
      const isWebLiveQuiz =
        homework?.modeOfConduction ===
        ModeOfConductionEnum.MODE_OF_CONDUCTION_WEB_LIVE;

      if (
        isWebLiveQuiz &&
        teacher_id &&
        homework?.sectionId &&
        homework.assessmentId
      ) {
        try {
          const sessions = await fetchPreviousSessions(
            BigInt(teacher_id),
            homework.sectionId,
            homework.assessmentId
          );

          const completed = sessions
            .filter(
              (session) =>
                session.sessionStatus ===
                SessionStatusEnum.SESSION_STATUS_COMPLETED
            )
            .sort(
              (a, b) =>
                Number(a.sessionStartTime?.seconds ?? 0) -
                Number(b.sessionStartTime?.seconds ?? 0)
            );

          setPreviousLiveQuizSessions(completed);

          // The latest completed session has the highest chronological number.
          const latestAttemptNumber = completed.length || undefined;

          setSelectedLiveQuizAttemptNumber(latestAttemptNumber);

          if (latestAttemptNumber !== undefined) {
            dispatch(setSelectedLiveQuizAttempt(latestAttemptNumber));
          }

          await getHomeworkDetails(selected_assessment_id, latestAttemptNumber);
          return;
        } catch (error) {
          console.error('Error fetching Web Live Quiz attempts:', error);
        }
      }

      // Existing behavior for non-Web-Live-Quiz homework, or when
      // no attempt history is available.
      setPreviousLiveQuizSessions([]);
      setSelectedLiveQuizAttemptNumber(undefined);
      await getHomeworkDetails(selected_assessment_id);
    };

    void loadHomework();
  }, [selected_assessment_id, selectedSection]);

  // -----------------------------------------------------
  const backButtonClick = async () => {
    const from = location.state?.from;
    if (from === '/home') {
      navigate(HOME);
    } else {
      navigate(HOMEWORK_MANAGE);
    }
  };

  // -----------------------------------------------------

  useEffect(() => {
    setSelectedFunction(() => backButtonClick);
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  const createChartData = (bloomData: BloomLevelBreackdown) => {
    const mappings = [
      { key: 'retentionScore', title: 'Retention', color: '#005DAA' },
      { key: 'comprehensionScore', title: 'Comprehension', color: '#3498DB' },
      { key: 'applicationScore', title: 'Application', color: '#5DC151' },
      { key: 'analysisScore', title: 'Analysis', color: '#FA8D49' },
      { key: 'creationScore', title: 'Creation', color: '#00BFC8' },
      { key: 'evaluationScore', title: 'Evaluation', color: '#E80000' },
    ] as const;
    const hasValidData = mappings.some(
      ({ key }) =>
        bloomData[key] !== undefined &&
        bloomData[key] !== null &&
        bloomData[key] !== 0
    );

    if (!hasValidData) {
      return []; // Return an empty array if no valid data is present
    }

    return mappings.map(({ key, title, color }) => ({
      obtainedMarks: bloomData[key] || 0,
      maxMarks: 100,
      title,
      color,
    }));
  };
  const classSection = [currentHomwork?.class, currentHomwork?.section]
    .filter(Boolean)
    .join(' ');
  const subtitleParts = [
    classSection,
    currentHomwork?.subject,
    currentHomwork?.moduleName,
  ]
    .filter(Boolean)
    .join(' | ');

  // -----------------------------------------------------

  const fetchAssessmentContent = async (homeworkId: bigint) => {
    try {
      const response =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: teacher_id,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: homeworkId,
          }
        );
      if (response.data) {
        setAssessmentContent(response.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // -----------------------------------------------------

  const getOMRAssessmentClassStats = async (homeworkId: bigint) => {
    try {
      const response =
        await LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler.getOmrAssessmentClassStats(
          { assessmentId: homeworkId }
        );
      if (response.data) {
        setOmrClassStats(response.data);
      } else {
        throw new Error('No data found');
      }
    } catch (error) {
      throw new Error('Error fetching OMR assessment class stats');
    }
  };

  // -----------------------------------------------------

  const getHomeworkDetails = async (
    homeworkId: bigint,
    attemptNumber?: number
  ) => {
    try {
      setLoading(true);
      const response =
        await LmsAssessmentTeacherAPIServiceV3WithStatusCodeHandler.getAssessmentClassStats(
          {
            teacherId: BigInt(teacher_id),
            assessmentId: homeworkId,
            multiSubjectSectionRequest: {
              sectionNo: selectedSection?.sectionNo,
              subjectId: selectedSection?.subjectId,
            },
            attemptNumber: attemptNumber,
          }
        );
      if (response.data) {
        if (
          response.data.assessment?.modeOfConduction ===
          ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
        ) {
          // it is added here as assessment details are not coming in getOmrAssessmentClassStats
          await Promise.all([
            getOMRAssessmentClassStats(homeworkId),
            fetchAssessmentContent(homeworkId),
          ]);
        }

        if (selectedSection) {
          setHwClassStatsSectionWise(response.data);
        } else {
          setHwClassStats(response.data);
          setHwClassStatsSectionWise(undefined);
        }
        const StatusObj: IStatusObj = {};
        response.data.studentPerformanceInfo.forEach((e) => {
          const id = e.studentId.toString();
          StatusObj[id] = {
            studentId: BigInt(e.studentId),
            isSubmitted: e.isSubmitted || false,
            marks: convertPercentageToMarks(
              e.scorePercent,
              response.data?.assessment?.maxMarks
            ),
          };
        });
        updateStatusObject(StatusObj);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(true);
      console.log(err);
    }
  };

  // -----------------------------------------------------

  const physicalHwSubmitHandler = async (props: ISubmissionProps) => {
    const { checkedValue, marks, studentData } = props;
    //if max marks are there student data is taken from student info because in that case a pop up is needed which requires that data but if maxmarks are not present
    //then whole operation is to be done on radio button click , so data cannot be taken form local variable
    if (!studentInfo && !studentData) {
      return;
    }
    const studentPerformaceData = studentInfo || studentData;
    const isSubmittedStatus = marks !== undefined ? true : checkedValue;
    if (marks !== undefined) {
      const regex = /^\d+$/;
      if (!regex.test(marks.toString())) {
        dispatch(
          setToastInfo({
            label: 'Marks can be whole numbers only',
            variant: 'error',
            open: true,
          })
        );
        return;
      }
    }
    try {
      setLoading(true);
      const submissionsInfo = new StudentSubmissionInfo({
        studentId: studentPerformaceData?.studentId,
        isSubmitted: isSubmittedStatus,
      });
      if (isSubmittedStatus && marks !== undefined) {
        submissionsInfo.obtainedMarks = marks;
      }
      const response =
        await LmsHomewokTeacherAPIServiceV1ClientWithStatusCodeHandler.studentHWPhysicalSubmissionUpdate(
          {
            teacherId: BigInt(teacher_id),
            homeworkId: selected_assessment_id,
            submissionsInfo: [submissionsInfo],
            maxMarks: currentHomwork?.maxMarks || 0,
          }
        );
      if (response) {
        console.log('response PhysicalHwSubmitHandler', response);
        const id = studentPerformaceData?.studentId.toString();
        //making changes in local status obj
        if (id && StatusObject && StatusObject[id]) {
          StatusObject[id].marks = marks;
          StatusObject[id].isSubmitted = isSubmittedStatus; //changing the status
        }

        updateStatusObject(StatusObject);
        selected_assessment_id && getHomeworkDetails(selected_assessment_id);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // -----------------------------------------------------

  const cardOnClick = (studentId: string) => {
    const modifiedId = String(studentId).split(' - ')[1];
    const pathStudentId = modifiedId || '0';
    const conductionMode = hwClassStatsSectionWise
      ? hwClassStatsSectionWise?.assessment?.modeOfConduction
      : hwClassStats?.assessment?.modeOfConduction;
    const omrMode =
      conductionMode === ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR;
    const isLiveQuiz =
      conductionMode === ModeOfConductionEnum.MODE_OF_CONDUCTION_WEB_LIVE;
    // setMarksPopupDisplay(true);
    // navigate(`${HOMEWORK_SUBMISSION_CUSTOM}/${studentId}`);
    const student = StatusObject && StatusObject[studentId.toString()];
    switch (currentHomwork?.submissionType) {
      case SubmissionType.SUBMISSION_OFFLINE:
        // if (current_homework_classStats.homework.maxMarks) {
        //   setMarksPopupDisplay(true);
        // }
        //replaced with marksTextClickHandler as per new reqs
        break;
      case SubmissionType.SUBMISSION_ONLINE:
        if (student?.isSubmitted) {
          navigate(`${HOMEWORK_SUBMISSION_CUSTOM}/${studentId}`);
        }
        break;
      default:
        omrMode
          ? navigate(
              `${HOMEWORK_PERFORMANCE}/${pathStudentId}?omrMode=true&omrStudentId=${encodeURIComponent(
                studentId
              )}`
            )
          : navigate(
              `${HOMEWORK_PERFORMANCE}/${studentId}${
                isLiveQuiz && selectedLiveQuizAttemptNumber !== undefined
                  ? `?attemptNumber=${selectedLiveQuizAttemptNumber}`
                  : ''
              }`
            );
    }
  };

  // -----------------------------------------------------

  const marksTextClickHandler = (student: StudentPerformanceInfo) => {
    setStudentInfo(student);
    if (currentHomwork?.submissionType === SubmissionType.SUBMISSION_OFFLINE) {
      if (currentHomwork.maxMarks) {
        setMarksPopupDisplay(true);
      }
    }
  };

  // -----------------------------------------------------

  const handleSectionChange = (event: SelectChangeEvent) => {
    if (event.target.value === '-1') {
      setSelectedSection(undefined);
      return;
    }
    setSelectedSection(
      hwClassStats?.multiSubjectMetrics?.find(
        (section) => section.sectionNo === Number(event.target.value)
      )
    );
  };

  // -----------------------------------------------------

  const currentConductionMode = () => {
    const conductionMode = hwClassStatsSectionWise
      ? hwClassStatsSectionWise?.assessment?.modeOfConduction
      : hwClassStats?.assessment?.modeOfConduction;
    return conductionMode;
  };

  const getStudentsSubmissionCount = () => {
    if (
      currentConductionMode() ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    ) {
      return omrClassStats?.studentPerformanceInfo?.filter(
        (student) => student.isSubmitted
      )?.length;
    }
    // return hwClassStats?.studentsSubmissionCount;
    return hwClassStatsSectionWise
      ? hwClassStatsSectionWise?.studentsSubmissionCount
      : hwClassStats?.studentsSubmissionCount;
  };

  // -----------------------------------------------------

  const getAssignedStudentsCount = () => {
    if (
      currentConductionMode() ===
      ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
    ) {
      return omrClassStats?.studentPerformanceInfo?.length;
    }
    // return hwClassStats?.studentPerformanceInfo?.length;
    return hwClassStatsSectionWise
      ? hwClassStatsSectionWise?.assignedStudentsCount
      : hwClassStats?.assignedStudentsCount;
  };

  // -----------------------------------------------------

  const getStudentPerformanceInfoList = () => {
    const conductionMode = hwClassStatsSectionWise
      ? hwClassStatsSectionWise?.assessment?.modeOfConduction
      : hwClassStats?.assessment?.modeOfConduction;
    if (conductionMode === ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR) {
      return omrClassStats?.studentPerformanceInfo;
    }

    return hwClassStatsSectionWise
      ? hwClassStatsSectionWise?.studentPerformanceInfo
      : hwClassStats?.studentPerformanceInfo;
  };

  // -----------------------------------------------------

  const hasSuccessfulUpload = omrScanFile?.some(
    (upload) =>
      !upload.uploadFileData.isDeleted && upload.fileUploadStatus === 'success'
  );

  // -----------------------------------------------------

  const uploadStudentData = async (filesToUpload: FileList) => {
    if (!filesToUpload?.length) return;

    if (filesToUpload.length > 1) {
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: 'Only one file can be uploaded at a time.',
          open: true,
        })
      );
      return;
    }

    const selectedFile = filesToUpload[0];
    if (!selectedFile) return;

    if (hasSuccessfulUpload) {
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: 'Only one file can be added at a time.',
          open: true,
        })
      );
      return;
    }

    if (
      ![
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].includes(selectedFile.type)
    ) {
      dispatch(
        setToastInfoV2({
          label: 'Please upload a valid Excel file (.xls or .xlsx)',
          variant: 'error',
          open: true,
        })
      );

      return;
    }

    const tempUserUploads: CustomUploadFileResponse = {
      uploadFileData: new CloudUpload({
        gcpFileUrl: '',
        personId: user_info?.teacherProfileId,
        fileSizeInMb: getFileSizeInMB(selectedFile.size),
        isDeleted: false,
        fileName: selectedFile.name,
        fileType: getFileType(selectedFile.type),
        fileExtensionType: getFileExtensionType(selectedFile.type),
        isUploaded: false,
        signedUrl: '',
      }),
      fileUploadStatus: 'pending',
      fileSize: selectedFile.size,
    };

    setOmrScanFile([tempUserUploads]);

    try {
      setLoading(true);

      const signedUrlResponse: SignedUrlReponse =
        await LmsCommonAPIServiceV2ClientWithStatusCodeHandler.getSignedUrlForFileUpload(
          {
            personId: BigInt(teacher_id),
            filesInfo: [
              {
                originalFilePath: selectedFile.name,
                mimeType: MimeEnum.MIME_XLSX,
                size:
                  getFileSizeInMB(selectedFile.size) < 0.01
                    ? 0.01
                    : getFileSizeInMB(selectedFile.size),
              },
            ],
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            fileUploadPurpose: FileUploadPurpose.FILE_UPLOAD_FOR_OMR_IMPORT,
            schoolId: user_info?.schoolDetails[0]?.schoolId,
          }
        );

      if (signedUrlResponse && signedUrlResponse.response.length > 0) {
        tempUserUploads.uploadFileData.signedUrl =
          signedUrlResponse.response[0].signedUrl;
        const signedUrl = getMediaBasePath(
          signedUrlResponse.response[0].signedUrl
        );
        const uploadSuccess = await uploadFile({
          file: selectedFile,
          signedUrl,
        });
        if (uploadSuccess.success === true) {
          // If upload is successful, update status to 'success'
          tempUserUploads.uploadFileData.gcpFileUrl =
            signedUrlResponse.response[0].signedUrl;
          tempUserUploads.uploadFileData.isUploaded = true;
          tempUserUploads.fileUploadStatus = 'success';
          setOmrScanFile([tempUserUploads]);
          const uploadExcelResponse =
            await SchoolAssessmentAPIServiceV1ClientWithStatusCodeHandler.importOmrResponsesFromExcel(
              {
                assessmentId: selected_assessment_id,
                filesInfo: [tempUserUploads.uploadFileData],
                // dateOfAssessment:
                dateOfAssessment: Timestamp.fromDate(
                  new Date('2026-05-14T10:30:00Z')
                ),
              }
            );
          setOmrScanFile([]);
          setOpenOmrUploadPopup(false);
          dispatch(
            setToastInfoV2({
              variant: 'success',
              label: 'OMR responses imported successfully',
              open: true,
            })
          );
          // await getClassStats();
          if (selected_assessment_id) {
            await getHomeworkDetails(selected_assessment_id);
          }
        } else {
          tempUserUploads.uploadFileData.isUploaded = false;
          tempUserUploads.fileUploadStatus = 'Upload Error';
          setOmrScanFile([]);
        }
      }
    } catch (error: any) {
      dispatch(
        setToastInfoV2({
          variant: 'error',
          label: error.rawMessage
            ? error.rawMessage?.replace(/.*\]\s*/, '').trim()
            : error.message
            ? error.message.replace(/.*\]\s*/, '').trim()
            : 'Error occurred while uploading assessment',
          open: true,
        })
      );
      setOmrScanFile([]);
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------------------

  const handleDropFunction = async (event: DragEvent<HTMLDivElement>) => {
    await uploadStudentData(event.dataTransfer.files);
  };

  const handleChangeFunction = async (event: ChangeEvent<HTMLInputElement>) => {
    await uploadStudentData(event.target.files as FileList);
    // Reset input value so selecting the same file again triggers onChange
    if (event.target) event.target.value = '';
  };

  const handleDeleteFunction = async (indexToDelete: number) => {
    setOmrScanFile(undefined);
  };

  // -----------------------------------------------------
  const stats = selectedSection ? hwClassStatsSectionWise : hwClassStats;
  const isMultiSubjectAssessment = stats?.assessment?.subjects
    ? stats?.assessment?.subjects.length > 1
    : false;

  const isJeeMarkingScheme =
    currentHomwork?.markingSchemeType === MarkingSchemeEnum.MARKING_SCHEME_JEE;

  interface ISection {
    name: string;
    id: number;
  }
  const sectionOptions: ISection[] = [
    ...(hwClassStats?.multiSubjectMetrics?.map((section) => ({
      name: `${getSubjectNameFromEnum(section?.subject)} ${
        section?.sectionTitle
      }`,
      id: section.sectionNo,
    })) || []),
    { name: 'All', id: -1 },
  ];

  // -----------------------------------------------------

  return loading === true ? (
    <Loader />
  ) : error === true ? (
    <Typography>Error Occured</Typography>
  ) : (
    <Box sx={styles.root}>
      <Box
        sx={{
          width: { xs: '100%', md: pxTovW(700), lg: pxTovW(610) },
          // backgroundColor: 'red',
        }}
      >
        <Box sx={styles.header}>
          <ImageWrapper
            name="chapterImage"
            type="png"
            parentFolder="tempAssets"
            path={getMediaBasePath(
              hwClassStats?.assessment?.assessmentPosterImgUrl,
              'processedMediaBucket'
            )}
            styles={styles.headImage}
          />
          <Box
            sx={{
              width: { xs: '70%', md: pxTovW(390) },
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(14), md: pxTovW(15) },
            }}
          >
            <Box>
              <Typography
                variant="h1"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  wordWrap: 'break-word',
                }}
              >
                {currentHomwork?.assessmentTitle || 'title'}
              </Typography>
              <Typography
                variant={isIpadOnly ? 'h4' : 'button'}
                color="primary"
                fontWeight="regular"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  width: '90%',
                }}
              >
                {subtitleParts}
              </Typography>
            </Box>
            <Box sx={{ width: { xs: pxToRem(178), md: pxTovW(300) } }}>
              {hwClassStats?.assessment?.maxMarks !== undefined && (
                <ScoreProgressBar
                  variant={largeScreen ? 'lg' : 'md'}
                  score={
                    Math.round(
                      Number(hwClassStats?.assessment?.classScore?.toFixed(2))
                    ) || 0
                  }
                />
              )}
            </Box>
          </Box>
        </Box>

        {isOmrAssessment() && (
          <OmrDownloadButtons
            assessmentContent={assessmentContent}
            assessmentTitle={currentHomwork?.assessmentTitle}
            rootStyles={{
              width: { xs: '100%', md: '100%', lg: '100%' },
              marginLeft: { xs: pxToRem(0), md: pxTovW(0) },
              marginTop: { xs: pxToRem(10), md: pxTovW(10) },
              marginBottom: { xs: pxToRem(10), md: pxTovW(40) },
            }}
          />
        )}

        {hwClassStats?.assessment?.taskType ===
          TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM && (
          <Box
            sx={{
              ...styles.iconBox,
              width: { xs: '100vw', md: '100%', lg: pxTovW(552) },
              height: { xs: pxToRem(70), md: pxTovW(160), lg: pxTovW(121) },
              marginLeft: { xs: pxToRem(0), md: pxTovW(0) },
            }}
          >
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: { xs: pxToRem(4), md: pxTovW(8) },
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                  }}
                >
                  <IconWrapper
                    name="user"
                    size={isIpadOnly ? 'large' : 'md'}
                    parentFolder="icons"
                    type="png"
                  />
                  <Typography variant="h2" fontWeight="bold">
                    {hwClassStats?.studentsSubmissionCount}/
                    {hwClassStats?.assignedStudentsCount}
                  </Typography>
                </Box>
                <Typography
                  variant="h4"
                  fontWeight="regular"
                  sx={{ color: '#828282' }}
                >
                  Submissions
                </Typography>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: { xs: pxToRem(4), md: pxTovW(8) },
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                  }}
                >
                  <IconWrapper
                    name="calender"
                    size="md"
                    parentFolder="icons"
                    type="png"
                  />
                  <Typography variant="h2" fontWeight="bold">
                    {formatDateAsDayMonth(currentHomwork?.assessmentTargetDate)}
                  </Typography>
                </Box>
                <Typography
                  variant="h4"
                  fontWeight="regular"
                  sx={{ color: '#828282' }}
                >
                  Deadline
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
        {/* {selected_assessment_id &&
          hwClassStats?.assessment?.taskType !==
            TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM && (
            <ViewReportButton homeworkId={selected_assessment_id} />
          )} */}
        {currentHomwork?.modeOfConduction ===
          ModeOfConductionEnum.MODE_OF_CONDUCTION_WEB_LIVE &&
          attemptOptionList.length > 0 && (
            <Box sx={{ width: '100%', mb: 2 }}>
              <SelectMenu
                placeholder="Attempt"
                value={
                  selectedLiveQuizAttemptNumber !== undefined
                    ? `Attempt ${selectedLiveQuizAttemptNumber}`
                    : ''
                }
                optionList={attemptOptionList}
                rootStyles={{ width: '100%' }}
                selectedBold
                onChange={(value: string) => {
                  const attemptNumber = Number(value.split(' ')[1]);

                  if (
                    !Number.isInteger(attemptNumber) ||
                    attemptNumber < 1 ||
                    !selected_assessment_id
                  ) {
                    return;
                  }

                  setSelectedLiveQuizAttemptNumber(attemptNumber);
                  dispatch(setSelectedLiveQuizAttempt(attemptNumber));

                  void getHomeworkDetails(
                    selected_assessment_id,
                    attemptNumber
                  );
                }}
              />
            </Box>
          )}
        {hwClassStats?.assessment?.assessmentType ===
          AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT &&
          hwClassStats?.assessment?.taskType ===
            TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: { xs: pxToRem(10), md: pxTovW(10) },
                marginTop: { xs: pxToRem(14), md: pxTovW(16) },
                marginBottom: { xs: pxToRem(10), md: pxTovW(10) },
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  borderTop: '1px dashed #8FC6E8',
                  height: 0,
                }}
              />

              <FormControl
                size="medium"
                sx={{
                  minWidth: { xs: pxToRem(130), md: pxTovW(130) },
                  '& .MuiOutlinedInput-root': {
                    borderRadius: pxToRem(8),
                    backgroundColor: '#F4FAFF',
                    height: { xs: pxToRem(34), md: pxTovW(60) },
                    '& fieldset': {
                      borderColor: '#64A6D6',
                    },
                    '&:hover fieldset': {
                      borderColor: '#64A6D6',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#64A6D6',
                    },
                  },
                }}
              >
                <Select
                  size="medium"
                  value={selectedSection?.sectionNo?.toString() || '-1'}
                  title={
                    selectedSection
                      ? `${getSubjectNameFromEnum(selectedSection?.subject)}- ${
                          selectedSection?.sectionTitle
                        }`
                      : 'All'
                  }
                  onChange={handleSectionChange}
                  displayEmpty
                  sx={{
                    width: { xs: pxToRem(200), md: pxTovW(250) },
                    height: { xs: pxToRem(34), md: pxTovW(60) },
                    fontSize: { xs: pxToRem(13), md: pxTovW(20) },
                    color: '#1F1F1F',
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: pxToRem(0),
                        marginTop: pxToRem(4),
                        boxShadow: '0px 4px 14px #0000001F',
                        border: '1px solid #C9E6D6',
                        '& .MuiMenu-list': {
                          paddingTop: 0,
                          paddingBottom: 0,
                          backgroundColor: '#EFF8F2',
                        },
                      },
                    },
                  }}
                >
                  {sectionOptions.map((section) => (
                    <MenuItem
                      key={section.id}
                      value={section.id?.toString() || '-1'}
                      sx={{
                        fontSize: { xs: pxToRem(13), md: pxTovW(20) },
                        color: '#4A4A4A',
                        minHeight: { xs: pxToRem(32), md: pxTovW(32) },
                        borderBottom: '1px solid #C9E6D6',
                        '&:last-of-type': {
                          borderBottom: 'none',
                        },
                        '&.Mui-selected': {
                          backgroundColor: '#DDEEE3',
                        },
                        '&.Mui-selected:hover': {
                          backgroundColor: '#DDEEE3',
                        },
                      }}
                    >
                      {section.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box
                sx={{
                  flex: 1,
                  borderTop: '1px dashed #8FC6E8',
                  height: 0,
                }}
              />
            </Box>
          )}

        {hwClassStats?.assessmentReportInfo?.bloomLevelBreackdown &&
          hwClassStats?.assessment?.taskType !==
            TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM &&
          hwClassStats?.assessment?.taskType !==
            TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM && (
            <ChartBox
              taskType={
                hwClassStats?.assessment?.taskType || TaskEnum.TASK_UNDEFINED
              }
              assessmentType={hwClassStats?.assessment?.assessmentType}
              homeworkId={selected_assessment_id}
              chartData={createChartData(
                hwClassStats?.assessmentReportInfo.bloomLevelBreackdown
              )}
              subjectName={''} //todo
              jeeMarking={
                currentHomwork?.markingSchemeType ===
                MarkingSchemeEnum.MARKING_SCHEME_JEE
              }
              reportSubject={
                currentHomwork?.subjects?.length
                  ? currentHomwork.subjects.join('_')
                  : currentHomwork?.subject
              }
              reportClassName={currentHomwork?.class}
              reportSection={currentHomwork?.section}
              modeOfConduction={
                hwClassStatsSectionWise
                  ? hwClassStatsSectionWise?.assessment?.modeOfConduction
                  : hwClassStats?.assessment?.modeOfConduction
              }
              attemptNumber={selectedLiveQuizAttemptNumber}
            />
          )}

        {hwClassStatsSectionWise?.assessmentReportInfo?.bloomLevelBreackdown &&
          hwClassStatsSectionWise?.assessment?.taskType !==
            TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM &&
          hwClassStatsSectionWise?.assessment?.assessmentType ===
            AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT &&
          selectedSection !== undefined && (
            <ChartBox
              taskType={hwClassStatsSectionWise?.assessment?.taskType}
              assessmentType={
                hwClassStatsSectionWise?.assessment?.assessmentType
              }
              homeworkId={selected_assessment_id}
              chartData={createChartData(
                hwClassStatsSectionWise?.assessmentReportInfo
                  .bloomLevelBreackdown
              )}
              subjectName={`${getSubjectNameFromEnum(
                selectedSection?.subject
              )} ${selectedSection?.sectionTitle}`}
              jeeMarking={
                currentHomwork?.markingSchemeType ===
                MarkingSchemeEnum.MARKING_SCHEME_JEE
              }
              reportSubject={
                currentHomwork?.subjects?.length
                  ? currentHomwork.subjects.join('_')
                  : currentHomwork?.subject
              }
              reportClassName={currentHomwork?.class}
              reportSection={currentHomwork?.section}
              modeOfConduction={
                hwClassStatsSectionWise
                  ? hwClassStatsSectionWise?.assessment?.modeOfConduction
                  : hwClassStats?.assessment?.modeOfConduction
              }
              attemptNumber={selectedLiveQuizAttemptNumber}
            />
          )}
        {hwClassStats?.assessment?.assessmentType ===
          AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT &&
          hwClassStats?.assessment?.taskType ===
            TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM &&
          selectedSection === undefined && (
            <Box
              sx={{
                width: '100%',
                border: '1px solid #E3E3E3',
                borderRadius: { xs: pxToRem(12), md: pxTovW(12) },
                backgroundColor: '#FFFFFF',
                padding: { xs: pxToRem(12), md: pxTovW(14) },
                boxSizing: 'border-box',
                marginBottom: { xs: pxToRem(12), md: pxTovW(12) },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: { xs: pxToRem(10), md: pxTovW(12) },
                }}
              >
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  sx={{ color: '#222222' }}
                >
                  Subject-Wise Overview
                </Typography>

                <Box sx={{ marginTop: '-10px' }}>
                  <ViewReportButton
                    homeworkId={selected_assessment_id || BigInt(0)}
                    subject={
                      currentHomwork?.subjects?.length
                        ? currentHomwork.subjects.join('_')
                        : currentHomwork?.subject
                    }
                    className={currentHomwork?.class}
                    section={currentHomwork?.section}
                    modeOfConduction={
                      hwClassStatsSectionWise
                        ? hwClassStatsSectionWise?.assessment?.modeOfConduction
                        : hwClassStats?.assessment?.modeOfConduction
                    }
                    attemptNumber={selectedLiveQuizAttemptNumber}
                  />
                </Box>

                {/* <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #7CCF96',
                    color: '#18984B',
                    borderRadius: pxToRem(6),
                    padding: {
                      xs: `${pxToRem(4)} ${pxToRem(10)}`,
                      md: pxTovW(8),
                    },
                    fontSize: { xs: pxToRem(11), md: pxTovW(12) },
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                >
                  Full Report
                </Box> */}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: pxToRem(8), md: pxTovW(8) },
                }}
              >
                {hwClassStats?.multiSubjectMetrics?.map((section) => (
                  <Box
                    key={section.subject}
                    sx={{
                      width: '100%',
                      border: '1px solid #ECECEC',
                      borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
                      backgroundColor: '#FFFFFF',
                      padding: { xs: pxToRem(10), md: pxTovW(10) },
                      boxSizing: 'border-box',
                      gap: { xs: pxToRem(10), md: pxTovW(10) },
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      boxShadow: `0px 0px ${pxToRem(10)} #0000001F`,
                    }}
                  >
                    <ChipBadge
                      label={`${getSubjectNameFromEnum(section?.subject)} ${
                        section?.sectionTitle
                      }`}
                      color="primary"
                      size="small"
                      sx={{
                        fontSize: pxToRem(10),
                      }}
                    />

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        gap: { xs: pxToRem(8), md: pxTovW(8) },
                        width: '100%',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: { xs: pxToRem(5), md: pxTovW(10) },
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: pxToRem(5), md: pxTovW(10) },
                          }}
                        >
                          <IconWrapper
                            name="questions"
                            size={isIpadOnly ? 'large' : 'md'}
                            parentFolder="icons"
                            type="png"
                          />
                          <Typography
                            variant="h3"
                            fontWeight="bold"
                            sx={{ color: '#1F1F1F' }}
                          >
                            {section.numberOfQuestions || 0}
                          </Typography>
                        </Box>
                        <Typography
                          variant="smallText"
                          sx={{ color: '#777777' }}
                        >
                          Questions
                        </Typography>
                      </Box>

                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ backgroundColor: '#E8E8E8' }}
                      />

                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: { xs: pxToRem(5), md: pxTovW(10) },
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: pxToRem(5), md: pxTovW(10) },
                          }}
                        >
                          <IconWrapper
                            name="bar-graph"
                            size={isIpadOnly ? 'large' : 'md'}
                            parentFolder="icons"
                            type="png"
                          />
                          <Typography
                            variant="h3"
                            fontWeight="bold"
                            sx={{ color: '#1F1F1F' }}
                          >
                            {getDifficultyLevelString(
                              section.avgDifficultyLevel
                            )}
                          </Typography>
                        </Box>
                        <Typography
                          variant="smallText"
                          sx={{ color: '#777777' }}
                        >
                          Difficulty
                        </Typography>
                      </Box>

                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ backgroundColor: '#E8E8E8' }}
                      />

                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: { xs: pxToRem(5), md: pxTovW(10) },
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: pxToRem(5), md: pxTovW(10) },
                          }}
                        >
                          <IconWrapper
                            name="percentage-primary"
                            size={isIpadOnly ? 'large' : 'md'}
                            parentFolder="icons"
                            type="png"
                          />
                          <Typography
                            variant="h3"
                            fontWeight="bold"
                            sx={{ color: '#1F1F1F' }}
                          >
                            {section.classSubjectMaxScore || 0}
                          </Typography>
                        </Box>
                        <Typography
                          variant="smallText"
                          sx={{ color: '#777777' }}
                        >
                          Total Marks
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          )}
        {hwClassStats?.assessment?.taskType !==
          TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM &&
          hwClassStats?.assessment?.taskType !==
            TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM && (
            <StrengthsWeaknessesSection
              resultData={{
                strengths:
                  hwClassStats?.assessmentReportInfo?.strengthsAndWeaknessess
                    ?.strength || [],
                weakness:
                  hwClassStats?.assessmentReportInfo?.strengthsAndWeaknessess
                    ?.weakness || [],
              }}
            />
          )}
        {hwClassStatsSectionWise?.assessment?.taskType !==
          TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM &&
          hwClassStatsSectionWise?.assessment?.taskType ===
            TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM &&
          selectedSection !== undefined && (
            <StrengthsWeaknessesSection
              resultData={{
                strengths:
                  hwClassStatsSectionWise?.assessmentReportInfo
                    ?.strengthsAndWeaknessess?.strength || [],
                weakness:
                  hwClassStatsSectionWise?.assessmentReportInfo
                    ?.strengthsAndWeaknessess?.weakness || [],
              }}
            />
          )}
        {hwClassStats?.assessment?.assessmentType ===
          AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT &&
        hwClassStats?.assessment?.taskType ===
          TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM &&
        selectedSection === undefined &&
        hwClassStats.assessment.classScore ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(10), md: pxTovW(10) },
              width: { xs: '90%', md: '100%' },
              margin: { xs: 'auto', md: '0' },
              border: '1px solid #E5E5E5',
              borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
              backgroundColor: '#F6F6F6',
              boxSizing: 'border-box',
              padding: { xs: pxToRem(14), md: pxTovW(14) },
              mb: { xs: pxToRem(20), md: 0 },
            }}
          >
            <Typography
              variant="h3"
              fontWeight="bold"
              sx={{ color: '#333333' }}
            >
              Subject-Wise Class Score
            </Typography>
            <Box
              sx={{
                width: '100%',
                marginTop: { xs: pxToRem(8), md: pxTovW(8) },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <OverLappingPieChart
                data={hwClassStats?.multiSubjectMetrics?.map((section) => ({
                  label: `${getSubjectNameFromEnum(section.subject)} ${
                    section.sectionTitle
                  }`,
                  index: section.sectionNo,
                  value: section.classSubjectScoreInPercent || 0,
                  color: '',
                }))}
                width={isMobile ? 350 : isIpadOnly ? 300 : 450}
              />
            </Box>
          </Box>
        ) : null}
        {/* <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
          }}
        >
          <PrimaryButton sx={{ margin: 'auto' }}>
            View Recommendation
          </PrimaryButton>
        </Box> */}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: pxToRem(20), md: pxTovW(20) },
          boxSizing: 'border-box',
          // backgroundColor: 'red',
        }}
      >
        {hwClassStats?.assessment?.taskType ==
          TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end', // Aligns child to the right
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: { xs: pxToRem(4), md: pxTovW(8) },
                cursor: 'pointer',
                borderRadius: pxTovW(15),
                backgroundColor: '#158D29',
                width: '125px',
                margin: { xs: pxToRem(12), md: `${pxToRem(20)} 0` },
                padding: { xs: pxToRem(8), md: pxTovW(10) },
              }}
              onClick={() => navigate(`${ASSESSMENT_VIEW}/ended`)}
            >
              <IconWrapper
                name="questions"
                size={isIpadOnly ? 'large' : 'md'}
                parentFolder="icons"
                type="png"
              />
              <Typography
                variant="smallText"
                fontWeight="bold"
                sx={{ color: '#FFFFFF' }}
              >
                VIEW ASSESSMENT
              </Typography>
            </Box>
          </Box>
        )}

        {hwClassStats?.assessment?.taskType !==
          TaskEnum.TASK_HOMEWORK_TEACHER_CUSTOM &&
        hwClassStats?.assessment?.taskType !==
          TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM ? (
          <Box sx={styles.iconBox}>
            <Box
              sx={{
                width: '100%',
                boxSizing: 'border-box',
                display: 'flex',
                gap: pxToRem(20),
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingX: { xs: pxToRem(12), md: pxTovW(26) },
                paddingTop: { xs: pxToRem(6), md: 0 },
              }}
            >
              <Typography variant="bodyText" fontWeight="bold">
                Test Overview
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: { xs: pxToRem(4), md: pxTovW(8) },
                  cursor: 'pointer',
                  borderRadius: pxTovW(15),
                  backgroundColor: '#158D29',
                  padding: { xs: pxToRem(8), md: pxTovW(10) },
                }}
                onClick={() => navigate(`${ASSESSMENT_VIEW}/ended`)}
              >
                <IconWrapper
                  name="questions"
                  size={isIpadOnly ? 'large' : 'md'}
                  parentFolder="icons"
                  type="png"
                />
                <Typography
                  variant="smallText"
                  fontWeight="bold"
                  sx={{ color: '#FFFFFF' }}
                >
                  VIEW ASSESSMENT
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                paddingX: { xs: pxToRem(10), md: pxTovW(26) },
                boxSizing: 'border-box',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  // alignItems: 'center',
                  gap: { xs: pxToRem(15), md: pxTovW(15) },
                  justifyContent: 'left',
                }}
              >
                <IconWrapper
                  name="questions"
                  size="large"
                  parentFolder="icons"
                  type="png"
                  customSx={{
                    height: { xs: pxToRem(25), lg: pxTovW(40) },
                    width: { xs: pxToRem(25), lg: pxTovW(40) },
                    mt: pxToRem(4),
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'left',
                    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                  }}
                >
                  <Typography variant="h2" fontWeight="bold">
                    {currentHomwork?.assessmentContentInfo?.numberOfQuestions}
                  </Typography>
                  <Typography
                    variant="h4"
                    fontWeight="regular"
                    sx={{ color: '#828282' }}
                  >
                    Questions
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  gap: { xs: pxToRem(10), md: pxTovW(20) },
                  height: '100%',
                }}
              >
                <Divider
                  orientation="vertical"
                  sx={{
                    width: '1px',
                    height: '100%',
                    backgroundColor: '#E0DFDE',
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    // alignItems: 'center',
                    gap: { xs: pxToRem(15), md: pxTovW(15) },
                    // backgroundColor: 'red',
                    justifyContent: 'left',
                  }}
                >
                  <IconWrapper
                    name="bar-graph"
                    size="large"
                    parentFolder="icons"
                    type="png"
                    customSx={{
                      height: { xs: pxToRem(25), lg: pxTovW(40) },
                      width: { xs: pxToRem(25), lg: pxTovW(40) },
                      mt: pxToRem(4),
                    }}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'left',
                      gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                    }}
                  >
                    <Typography variant="h2" fontWeight="bold">
                      {getDifficultyLevelString(
                        currentHomwork?.difficultyLevel
                      )}
                    </Typography>
                    <Typography
                      variant="h4"
                      fontWeight="regular"
                      sx={{ color: '#828282' }}
                    >
                      Difficulty
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  gap: { xs: pxToRem(10), md: pxTovW(20) },
                  height: '100%',
                }}
              >
                <Divider
                  orientation="vertical"
                  sx={{
                    width: '1px',
                    height: '100%',
                    backgroundColor: '#E0DFDE',
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: { xs: pxToRem(15), md: pxTovW(15) },
                    // backgroundColor: 'red',
                    justifyContent: 'left',
                  }}
                >
                  <IconWrapper
                    name="calender"
                    size="large"
                    parentFolder="icons"
                    type="png"
                    customSx={{
                      height: { xs: pxToRem(25), lg: pxTovW(24.43) },
                      width: { xs: pxToRem(25), lg: pxTovW(26.43) },
                      mt: pxToRem(4),
                    }}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'left',
                      gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                    }}
                  >
                    <Typography variant="h2" fontWeight="bold">
                      {formatDateAsDayMonth(
                        currentHomwork?.assessmentTargetDate
                      )}
                    </Typography>
                    <Typography
                      variant="h4"
                      fontWeight="regular"
                      sx={{ color: '#828282' }}
                    >
                      Deadline
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              ...styles.iconBox,
              height: { xs: pxToRem(150), md: pxTovW(250), lg: pxTovW(209) },
            }}
          >
            <Box
              sx={{
                width: '100%',
                boxSizing: 'border-box',
                display: 'flex',
                gap: pxToRem(20),
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingX: { xs: pxToRem(20), md: pxTovW(26) },
                mt: { xs: pxToRem(12), md: 0 },
              }}
            >
              <Typography variant="bodyText" fontWeight="bold">
                Overall Summary
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: { xs: pxToRem(4), md: pxTovW(8) },
                  cursor: 'pointer',
                  borderRadius: pxTovW(15),
                  backgroundColor: '#158D29',
                  padding: { xs: pxToRem(8), md: pxTovW(10) },
                }}
                onClick={() => navigate(`${ASSESSMENT_VIEW}/ended`)}
              >
                <IconWrapper
                  name="questions"
                  size={isIpadOnly ? 'large' : 'md'}
                  parentFolder="icons"
                  type="png"
                />
                <Typography
                  variant="smallText"
                  fontWeight="bold"
                  sx={{ color: '#FFFFFF' }}
                >
                  VIEW ASSESSMENT
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                paddingX: { xs: pxToRem(12), md: pxTovW(26) },
                paddingY: { xs: pxToRem(10), md: 0 },
                gap: { xs: pxToRem(10), md: pxTovW(20) },
                boxSizing: 'border-box',
                alignItems: 'center',
                overflowX: { xs: 'auto', md: 'visible' },
                overflowY: 'hidden',
                WebkitOverflowScrolling: 'touch',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: { xs: pxToRem(15), md: pxTovW(15) },
                  justifyContent: 'center',
                  minWidth: { xs: pxToRem(110), md: 'auto' },
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                  }}
                >
                  <IconWrapper
                    name="userBlue"
                    size="md"
                    parentFolder="icons"
                    type="png"
                    customSx={{
                      height: { xs: pxToRem(15), lg: pxTovW(25) },
                      width: { xs: pxToRem(15), lg: pxTovW(25) },
                    }}
                  />
                  <Typography variant="h2" fontWeight="bold">
                    {currentConductionMode() ===
                    ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
                      ? omrClassStats?.studentPerformanceInfo?.length
                      : hwClassStats?.assignedStudentsCount || 0}
                  </Typography>
                </Box>

                <Typography
                  variant="h4"
                  fontWeight="regular"
                  sx={{ color: '#828282' }}
                >
                  Assessed
                </Typography>
              </Box>
              <Divider
                orientation="vertical"
                sx={{
                  width: '1px',
                  height: '100%',
                  backgroundColor: '#E0DFDE',
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: { xs: pxToRem(15), md: pxTovW(15) },
                  justifyContent: 'center',
                  minWidth: { xs: pxToRem(110), md: 'auto' },
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                  }}
                >
                  <IconWrapper
                    name="flashcards"
                    size="md"
                    parentFolder="icons"
                    type="png"
                    customSx={{
                      height: { xs: pxToRem(15), lg: pxTovW(25) },
                      width: { xs: pxToRem(15), lg: pxTovW(25) },
                    }}
                  />
                  <Typography variant="h2" fontWeight="bold">
                    {hwClassStats?.multiSubjectMetrics.length || 0}
                  </Typography>
                </Box>

                <Typography
                  variant="h4"
                  fontWeight="regular"
                  sx={{ color: '#828282' }}
                >
                  Subjects
                </Typography>
              </Box>
              <Divider
                orientation="vertical"
                sx={{
                  width: '1px',
                  height: '100%',
                  backgroundColor: '#E0DFDE',
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: { xs: pxToRem(15), md: pxTovW(15) },
                  justifyContent: 'center',
                  minWidth: { xs: pxToRem(110), md: 'auto' },
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                  }}
                >
                  <IconWrapper
                    name="bar-graph"
                    size="md"
                    parentFolder="icons"
                    type="png"
                    customSx={{
                      height: { xs: pxToRem(15), lg: pxTovW(25) },
                      width: { xs: pxToRem(15), lg: pxTovW(25) },
                    }}
                  />
                  <Typography variant="h2" fontWeight="bold">
                    {getDifficultyLevelString(
                      hwClassStats.assessment.difficultyLevel
                    )}
                  </Typography>
                </Box>

                <Typography
                  variant="h4"
                  fontWeight="regular"
                  sx={{ color: '#828282' }}
                >
                  Difficulty
                </Typography>
              </Box>
              <Divider
                orientation="vertical"
                sx={{
                  width: '1px',
                  height: '100%',
                  backgroundColor: '#E0DFDE',
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: { xs: pxToRem(15), md: pxTovW(15) },
                  justifyContent: 'center',
                  minWidth: { xs: pxToRem(110), md: 'auto' },
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                  }}
                >
                  <IconWrapper
                    name="questions"
                    size="md"
                    parentFolder="icons"
                    type="png"
                    customSx={{
                      height: { xs: pxToRem(15), lg: pxTovW(25) },
                      width: { xs: pxToRem(15), lg: pxTovW(25) },
                    }}
                  />
                  <Typography variant="h2" fontWeight="bold">
                    {currentHomwork?.assessmentContentInfo?.numberOfQuestions ||
                      0}
                  </Typography>
                </Box>

                <Typography
                  variant="h4"
                  fontWeight="regular"
                  sx={{ color: '#828282' }}
                >
                  Questions
                </Typography>
              </Box>
              <Divider
                orientation="vertical"
                sx={{
                  width: '1px',
                  height: '100%',
                  backgroundColor: '#E0DFDE',
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: { xs: pxToRem(15), md: pxTovW(15) },
                  justifyContent: 'center',
                  minWidth: { xs: pxToRem(110), md: 'auto' },
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
                  }}
                >
                  <IconWrapper
                    name="percentage-primary"
                    size="md"
                    parentFolder="icons"
                    type="png"
                    customSx={{
                      height: { xs: pxToRem(15), lg: pxTovW(25) },
                      width: { xs: pxToRem(15), lg: pxTovW(25) },
                    }}
                  />
                  <Typography variant="h2" fontWeight="bold">
                    {currentHomwork?.maxMarks || 0}
                  </Typography>
                </Box>

                <Typography
                  variant="h4"
                  fontWeight="regular"
                  sx={{ color: '#828282' }}
                >
                  Total Marks
                </Typography>
              </Box>
            </Box>
          </Box>
        )}

        {hwClassStatsSectionWise?.assessment?.assessmentType ===
          AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT &&
        hwClassStatsSectionWise?.assessment?.taskType ===
          TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM &&
        selectedSection !== undefined ? (
          <Box
            sx={{
              width: { xs: '100%', md: '97%', lg: pxTovW(794) },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: pxToRem(10),
              boxSizing: 'border-box',
              marginLeft: { xs: pxToRem(0), md: pxTovW(40), lg: pxTovW(40) },
            }}
          >
            <Box
              sx={{
                width: '100%',
                border: '1px solid #E8E8E8',
                borderRadius: { xs: 0, md: pxTovW(14) },
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 2px 8px #00000014',
                paddingY: { xs: pxToRem(12), md: pxTovW(12) },
                paddingX: { xs: pxToRem(5), md: pxTovW(12) },
                gap: { xs: pxToRem(10), md: pxTovW(10) },
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
                justifyContent: 'space-between',
                mt: { xs: pxToRem(10), md: pxTovW(10) },
              }}
            >
              <ChipBadge
                label={`${getSubjectNameFromEnum(selectedSection?.subject)} ${
                  selectedSection?.sectionTitle
                }`}
                color="primary"
                size="small"
                sx={{
                  fontSize: pxToRem(10),
                  ml: { xs: pxToRem(10), md: pxTovW(40) },
                }}
              />

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: pxToRem(10),
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: { xs: pxToRem(6), md: pxTovW(6) },
                    }}
                  >
                    <IconWrapper
                      name="questions"
                      size="md"
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="h2" fontWeight="bold">
                      {selectedSection?.numberOfQuestions || 0}
                    </Typography>
                  </Box>
                  <Typography
                    variant="smallText"
                    sx={{
                      color: '#777777',
                    }}
                  >
                    Questions
                  </Typography>
                </Box>

                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ backgroundColor: '#E8E8E8' }}
                />

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    gap: pxToRem(10),
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: { xs: pxToRem(6), md: pxTovW(6) },
                    }}
                  >
                    <IconWrapper
                      name="bar-graph"
                      size="md"
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="h2" fontWeight="bold">
                      {getDifficultyLevelString(
                        selectedSection?.avgDifficultyLevel
                      )}
                    </Typography>
                  </Box>
                  <Typography
                    variant="smallText"
                    sx={{
                      color: '#777777',
                    }}
                  >
                    Difficulty
                  </Typography>
                </Box>

                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ backgroundColor: '#E8E8E8' }}
                />

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    gap: pxToRem(10),
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: { xs: pxToRem(6), md: pxTovW(6) },
                    }}
                  >
                    <IconWrapper
                      name="clipboard-blue"
                      size="md"
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="h2" fontWeight="bold">
                      {selectedSection?.classSubjectMaxScore || 0}
                    </Typography>
                  </Box>
                  <Typography
                    variant="smallText"
                    sx={{
                      color: '#777777',
                    }}
                  >
                    Total Marks
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : null}

        {hwClassStatsSectionWise ? (
          <StudentSection
            Class={`${currentHomwork?.class} ${currentHomwork?.section}`}
            studentPerformanceInfoList={getStudentPerformanceInfoList()}
            cardMaxMarks={hwClassStatsSectionWise?.assessment?.maxMarks || 0}
            cardSubmissionType={
              currentHomwork?.submissionType as SubmissionType
            }
            cardOnClickHandler={cardOnClick}
            checkBoxClickHandler={physicalHwSubmitHandler}
            assignedStudentCount={getAssignedStudentsCount() || 0}
            studentSubmissionCount={getStudentsSubmissionCount() || 0}
            statusInfo={StatusObject}
            // saveStudentInfo={(e) => setStudentInfo(e)}
            textClickHandler={marksTextClickHandler}
            taskType={hwClassStatsSectionWise?.assessment?.taskType}
            assessmentId={selected_assessment_id}
            showBulkReportButton={true} // hide in case of MultiSubjects and JEE marking scheme
            isSummaryReportDisabled={
              isJeeMarkingScheme || isMultiSubjectAssessment
            }
            assessmentName={currentHomwork?.assessmentTitle}
            reportSubject={
              currentHomwork?.subjects?.length
                ? currentHomwork.subjects.join('_')
                : currentHomwork?.subject
            }
            reportClassName={currentHomwork?.class}
            reportSection={currentHomwork?.section}
            attemptNumber={selectedLiveQuizAttemptNumber}
          />
        ) : (
          <StudentSection
            Class={`${currentHomwork?.class} ${currentHomwork?.section}`}
            studentPerformanceInfoList={getStudentPerformanceInfoList()}
            cardMaxMarks={currentHomwork?.maxMarks || 0}
            cardSubmissionType={
              currentHomwork?.submissionType as SubmissionType
            }
            cardOnClickHandler={cardOnClick}
            checkBoxClickHandler={physicalHwSubmitHandler}
            assignedStudentCount={getAssignedStudentsCount() || 0}
            studentSubmissionCount={getStudentsSubmissionCount() || 0}
            statusInfo={StatusObject}
            // saveStudentInfo={(e) => setStudentInfo(e)}
            textClickHandler={marksTextClickHandler}
            taskType={hwClassStats?.assessment?.taskType}
            assessmentId={selected_assessment_id}
            showBulkReportButton={true} // hide in case of MultiSubjects and JEE marking scheme
            isSummaryReportDisabled={
              isJeeMarkingScheme || isMultiSubjectAssessment
            }
            assessmentName={currentHomwork?.assessmentTitle}
            reportSubject={
              currentHomwork && currentHomwork?.subjects?.length
                ? currentHomwork.subjects.join('_')
                : currentHomwork?.subject
            }
            reportClassName={currentHomwork?.class}
            reportSection={currentHomwork?.section}
            modeOfConduction={currentHomwork?.modeOfConduction}
            setOpenOmrUploadPopup={setOpenOmrUploadPopup}
            attemptNumber={selectedLiveQuizAttemptNumber}
          />
        )}
      </Box>

      {currentHomwork && (
        <MarksSubmitPopup
          open={marksPopupDisplay}
          totalMarks={currentHomwork.maxMarks || 0}
          handleClose={() => {
            setMarksPopupDisplay(false);
            setStudentInfo(undefined);
          }}
          submitClickHandler={physicalHwSubmitHandler}
        />
      )}

      <OmrUploadPopup
        open={openOmrUploadPopup}
        handleClose={() => setOpenOmrUploadPopup(false)}
        handleDropFunction={handleDropFunction}
        handleChangeFunction={handleChangeFunction}
        handleDeleteFunction={handleDeleteFunction}
        userUploads={omrScanFile ?? []}
        isUploading={loading}
      />
    </Box>
  );
};

const getSubjectColorBySubjectId = (
  subjectId?: number,
  teachClassSubjects?: TeachClassSubjects[]
): string => {
  if (subjectId == null || !teachClassSubjects?.length) return '';
  for (const classData of teachClassSubjects) {
    for (const subjectData of classData.subjects ?? []) {
      if (subjectData.subjectId === subjectId && subjectData.iconUrl) {
        return `${subjectData.textColor}`;
      }
    }
  }
  return '';
};

function getRandomColor() {
  // Define the range of RGB values for non-white colors
  const minColor = 50; // Minimum value for R, G, B to avoid white variations
  const maxColor = 255; // Maximum value for R, G, B (full brightness)
  // Generate random RGB values
  const r = Math.floor(Math.random() * (maxColor - minColor + 1)) + minColor;
  const g = Math.floor(Math.random() * (maxColor - minColor + 1)) + minColor;
  const b = Math.floor(Math.random() * (maxColor - minColor + 1)) + minColor;
  // Construct the RGB string
  const color = `rgb(${r}, ${g}, ${b})`;
  return color;
}
